import type { Maybe } from '@adornis/base/utilTypes';
import { BuildifyGlobalSettings, subscribeBuildifyGlobalSettings } from '@adornis/buildify/db/GlobalSettings';
import '@adornis/chemistry/elements/components/stack/x-stack.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar';
import { useForm } from '@adornis/forms/use-form';
import { stateful, useState } from '@adornis/functional-lit/stateful';
import { useQuery } from '@adornis/functional-lit/use-query';
import '@adornis/html-based-buildify/client/editor/x-editor';
import '@adornis/tiptap/client/x-tiptap';
import { html } from 'lit';
import { buildifyDefaultTiptapExtensions, customParagraph } from '../../../client/theme/buildify/helpers';
import { IconButton } from '../../design-system/client/IconButton';
import { Comment } from '../db/Comment';

export const AddComment = stateful(
  ({
    relatedEntityID,
    additionalInfo,
    commentClass,
    onCreated,
    globalSettingsClassName,
  }: {
    relatedEntityID;
    globalSettingsClassName: string;
    additionalInfo?: Record<string, any>;
    commentClass?: typeof Comment;
    onCreated?: () => void;
  }) => {
    const [comment] = useState(
      new (commentClass ?? Comment)({
        relatedEntityID,
        ...(additionalInfo ?? {}),
      }),
    );
    const commentController = useForm(comment);

    const { value: globalSettings } = useQuery(
      () =>
        new Promise<Maybe<BuildifyGlobalSettings>>((res, rej) => {
          subscribeBuildifyGlobalSettings(globalSettingsClassName)({
            colors: 1,
          }).subscribe(settings => {
            if (!settings) return rej('settings not found');
            return res(settings as BuildifyGlobalSettings);
          });
        }),
      [],
    );
    if (!globalSettings) return [];
    const tiptapExtensions = buildifyDefaultTiptapExtensions(customParagraph('text'), globalSettings, true);

    return html`
      <x-flex space="md">
        <x-tiptap mode="html" .extensions=${tiptapExtensions} ${commentController.field('text')}></x-tiptap>
        <x-flex crossaxis-end>
          ${IconButton({
            icon: 'up',
            tooltip: 'Kommentieren...',
            onClickHandler: () => {
              comment.create().then(() => {
                XSnackbar.show('Kommentar erstellt');
                onCreated?.();
              });
            },
          })}
        </x-flex>
      </x-flex>
    `;
  },
);
